import styled from 'styled-components';

import { donedealBreakpoints } from 'styled-system';

export const ActionsContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.S8};
  /**
   * Hides content that may otherwise appear in the space around the buttons.
   */
  background-color: ${({ theme }) => theme.donedeal.colors.WHITE};
  padding-bottom: ${({ theme }) => theme.spacing.M24};

  ${donedealBreakpoints.media.medium} {
    padding-bottom: ${({ theme }) => theme.spacing.L48};
  }
`;
